import React from 'react';
import ActionsBlock from './components/datatable/ActionsBlock';
import * as DatesUtils from '../../utils/dates';
import {
  Languages,
  AuthRoles,
  RegistrationStatus,
  RegistrationState,
  readableRegistrationStatus,
  readableRegistrationState,
} from '../../config';
import _ from 'lodash';

const CONFIGURATION = {};

export const allowedActions = {
  edit: {
    state_status: ['0N', '0U', '0E'],
    roles: AuthRoles.Registered,
  },
  update: {
    state_status: ['2A'],
    roles: AuthRoles.Registered,
  },
  exclude: {
    state_status: ['2A'],
    roles: AuthRoles.Registered,
  },
  cancel: {
    state_status: ['4A'],
    roles: [AuthRoles.Admin],
  },
};

export default CONFIGURATION;

const statusSelector = (status: string): string | null => {
  switch (status.toString()) {
    case '0':
      return 'Temporary';
    case '1':
      return 'Submited';
    case '2':
      return 'Approved';
    case '3':
      return 'Rejected';
    case '4':
      return 'Excluded';
    case '5':
      return 'Cancel Exclusion';
    default:
      return '-';
  }
};

const stateSelector = (state: string): string | null => {
  switch (state) {
    case 'A':
      return 'Active , Last Active';
    case 'N':
      return 'New';
    case 'U':
      return 'Update Request';
    case 'H':
      return 'History';
    case 'E':
      return 'Exclusion Request';
    default:
      return null;
  }
};

export const TableColumns = [
  {
    label: '#',
    id: 'registration_id',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => {
      return (
        <React.Fragment>
          <span
            style={{
              color:
                data[rowIndex].state === RegistrationState.ACTIVE
                  ? 'green'
                  : data[rowIndex].state === RegistrationState.UPDATE_REQUEST ||
                    data[rowIndex].state ===
                      RegistrationState.EXCLUSION_REQUEST ||
                    data[rowIndex].state === RegistrationState.NEW
                  ? '#FF4500'
                  : 'black',
            }}
          >
            {cellValue}
          </span>
        </React.Fragment>
      );
    },
    inData: true,
  },
  {
    label: 'Vat Number',
    id: 'vat_number',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => (
      <React.Fragment>
        <span
          style={{
            color:
              data[rowIndex].state === RegistrationState.ACTIVE
                ? 'green'
                : data[rowIndex].state === RegistrationState.UPDATE_REQUEST ||
                  data[rowIndex].state ===
                    RegistrationState.EXCLUSION_REQUEST ||
                  data[rowIndex].state === RegistrationState.NEW
                ? '#FF4500'
                : 'black',
          }}
        >
          {cellValue}
        </span>
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Company Name',
    id: 'company_name',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => (
      <React.Fragment>
        <span
          style={{
            color:
              data[rowIndex].state === RegistrationState.ACTIVE
                ? 'green'
                : data[rowIndex].state === RegistrationState.UPDATE_REQUEST ||
                  data[rowIndex].state ===
                    RegistrationState.EXCLUSION_REQUEST ||
                  data[rowIndex].state === RegistrationState.NEW
                ? '#FF4500'
                : 'black',
          }}
        >
          {cellValue}
        </span>
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Status',
    id: 'registration_status_id',
    align: 'left',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => (
      <React.Fragment>
        <span
          style={{
            color:
              data[rowIndex].state === RegistrationState.ACTIVE
                ? 'green'
                : data[rowIndex].state === RegistrationState.UPDATE_REQUEST ||
                  data[rowIndex].state ===
                    RegistrationState.EXCLUSION_REQUEST ||
                  data[rowIndex].state === RegistrationState.NEW
                ? '#FF4500'
                : 'black',
          }}
        >
          {readableRegistrationStatus[cellValue]}
        </span>
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'State',
    id: 'state',
    align: 'left',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => (
      <React.Fragment>
        <span
          style={{
            color:
              data[rowIndex].state === RegistrationState.ACTIVE
                ? 'green'
                : data[rowIndex].state === RegistrationState.UPDATE_REQUEST ||
                  data[rowIndex].state ===
                    RegistrationState.EXCLUSION_REQUEST ||
                  data[rowIndex].state === RegistrationState.NEW
                ? '#FF4500'
                : 'black',
          }}
        >
          {_.get(readableRegistrationState, cellValue, 'Unknown')}
        </span>
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Registration Date',
    id: 'registration_date',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => (
      <React.Fragment>
        <span
          style={{
            color:
              data[rowIndex].state === RegistrationState.ACTIVE
                ? 'green'
                : data[rowIndex].state === RegistrationState.UPDATE_REQUEST ||
                  data[rowIndex].state ===
                    RegistrationState.EXCLUSION_REQUEST ||
                  data[rowIndex].state === RegistrationState.NEW
                ? '#FF4500'
                : 'black',
          }}
        >
          {cellValue
            ? DatesUtils.formatDate(cellValue)
            : data[rowIndex].registration_status_id === 0 &&
              data[rowIndex].state === 'N'
            ? 'Pending User Submission'
            : 'Pending Approval'}
        </span>
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Commencement Date',
    id: 'commencement_date',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => (
      <React.Fragment>
        <span
          style={{
            color:
              data[rowIndex].state === RegistrationState.ACTIVE
                ? 'green'
                : data[rowIndex].state === RegistrationState.UPDATE_REQUEST ||
                  data[rowIndex].state ===
                    RegistrationState.EXCLUSION_REQUEST ||
                  data[rowIndex].state === RegistrationState.NEW
                ? '#FF4500'
                : 'black',
          }}
        >
          {cellValue ? DatesUtils.formatDate(cellValue) : '-'}
        </span>
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Change Date',
    id: 'change_date',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => (
      <React.Fragment>
        <span
          style={{
            color:
              data[rowIndex].state === RegistrationState.ACTIVE
                ? 'green'
                : data[rowIndex].state === RegistrationState.UPDATE_REQUEST ||
                  data[rowIndex].state ===
                    RegistrationState.EXCLUSION_REQUEST ||
                  data[rowIndex].state === RegistrationState.NEW
                ? '#FF4500'
                : 'black',
          }}
        >
          {DatesUtils.formatFullDateTime(cellValue)}
        </span>
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Actions',
    align: 'center',
    id: 'action1',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: any
    ) => (
      <ActionsBlock
        status={data[rowIndex].registration_status_id}
        state={data[rowIndex].state}
        registration_id={data[rowIndex].registration_id}
      />
    ),
    inData: false,
  },
];

interface ITableDefaultFetchValues {
  TABLE_DEFAULT_PAGE: number;
  TABLE_DEFAULT_PAGE_SIZE: number;
  TABLE_DEFAULT_ORDER: 'desc' | 'asc';
  TABLE_DEFAULT_SORT_KEY: string;
}

export const TableDefaultFetchValues: ITableDefaultFetchValues = {
  TABLE_DEFAULT_PAGE: 0,
  TABLE_DEFAULT_PAGE_SIZE: 25,
  TABLE_DEFAULT_ORDER: 'desc',
  TABLE_DEFAULT_SORT_KEY: TableColumns[0].id,
};

export const Translations = {
  page_title: {
    [Languages.Greek]: 'Registration',
    [Languages.English]: 'Registration',
  },
  manage_registration_title: {
    [Languages.Greek]: 'Manage Your One-Stop-Shop Registration',
    [Languages.English]: 'Manage Your One-Stop-Shop Registration',
  },
  manage_registration_description: {
    [Languages.Greek]:
      'Review your One-Stop-Shop Registration History from the list below. You can Update your latest Approved Registration or Submit any Temporary Registration updates that you might have made. Your Submitted Registration Form will go through the Approval procedure by a Tax Administration Officer. An approved Registration gives you access to all of the One-Stop-Shop Portal Services',
    [Languages.English]:
      'Review your One-Stop-Shop Registration History from the list below. You can Update your latest Approved Registration or Submit any Temporary Registration updates that you might have made. Your Submitted Registration Form will go through the Approval procedure by a Tax Administration Officer. An approved Registration gives you access to all of the One-Stop-Shop Portal Services',
  },
  table_title: {
    [Languages.Greek]: 'Registration Status And Update History',
    [Languages.English]: 'Registration Status And Update History',
  },
  go_to_dashboard: {
    [Languages.Greek]: 'Go to dasbhoard',
    [Languages.English]: 'Go to dasbhoard',
  },
  vat_number: {
    [Languages.Greek]: 'VAT Number',
    [Languages.English]: 'VAT Number',
  },
  status: {
    [Languages.Greek]: 'Status',
    [Languages.English]: 'Status',
  },
  state: {
    [Languages.Greek]: 'State',
    [Languages.English]: 'State',
  },
  search: {
    [Languages.Greek]: 'Search',
    [Languages.English]: 'Search',
  },
  clear: {
    [Languages.Greek]: 'Clear',
    [Languages.English]: 'Clear',
  },
};
